import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-logged-in-user-detail',
    templateUrl: './logged-in-user-detail.component.html',
    standalone: false,
})
export class LoggedInUserDetailComponent {
    @Input()
    public label: string;
}
